import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import { label, number, route } from "../../config";
import config from "../../env.config";
import { onBlur, onFocus, onOpen } from "../../utils/kendo";

/**
 *this component renders Pop-up which is used to open task in new tab
 * @author Sejal Bansal
 */
const NewTabPopUp = ({ anchor, showLinkPopUp, setShowLinkPopUp, taskId }) => {
  const dispatch = useDispatch();
  const deleteRef = useRef(null);
  const blurTimeoutRef = useRef(null);

  /**
   * this function is used to handle blur functionality of the pop-up when we we click anywhere outside the popup
   * @author Sejal
   */
  const hideOnBlur = () => {
    setShowLinkPopUp(false);
  };

  const onOpenPopup = () => {
    onOpen(deleteRef);
  };

  const onFocusPopup = () => {
    onFocus(blurTimeoutRef);
  };

  const onBlurPopup = () => {
    onBlur(blurTimeoutRef, hideOnBlur);
  };

  /**
   *this function is used to open task in new tab
   * @author Sejal Bansal
   */
  const openInNewTab = () => {
    setShowLinkPopUp(false);
    const url = `${config.BASE_URL.APP_URL}${route.PRIVATE_ROUTE.TASKS.PATH}?tId=${taskId}`;
    window.open(url, "_blank");
  };

  return (
    <Popup anchor={anchor?.current} show={showLinkPopUp} onOpen={onOpenPopup} className={"dt-popup new-tab-pop-up text-center"}>
      <div tabIndex={number.ZERO} id ="new-tab-popup" ref={deleteRef} onFocus={onFocusPopup} onBlur={onBlurPopup}>
        <label className='cursor-pointer text-style' onClick={openInNewTab}>
        {label.OPEN_LINK_IN_NEWTAB}
        </label>
      </div>
    </Popup>
  );
};

export default NewTabPopUp;
